import { render } from "./CompanyTypeBadge.vue?vue&type=template&id=431f7486&scoped=true"
import script from "./CompanyTypeBadge.vue?vue&type=script&lang=js"
export * from "./CompanyTypeBadge.vue?vue&type=script&lang=js"

import "./CompanyTypeBadge.vue?vue&type=style&index=0&id=431f7486&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-431f7486"]])

export default __exports__